'use client';

import { CardWithTitle, Form } from '@packages/chakra-v3';

import { LoginForm } from '../../components';
import { LoginFormSchema } from '../../schemas';
import type { LoginFormType } from '../../schemas';
import { useLogin } from '../../hooks';

const LoginContainer = () => {
	const { handleLoginWithCredential, handleLoginWithProvider } = useLogin();

	return (
		<CardWithTitle
			description={'Login to your account'}
			title={'Login'}
		>
			<Form.Provider<LoginFormType>
				schema={LoginFormSchema}
				onSubmit={handleLoginWithCredential}
			>
				<LoginForm onClickLoginWithGoogle={handleLoginWithProvider} />
			</Form.Provider>
		</CardWithTitle>
	);
};

export default LoginContainer;